import { render, staticRenderFns } from "./DashboardDefault.vue?vue&type=template&id=e13339fe"
import script from "./DashboardDefault.vue?vue&type=script&lang=js"
export * from "./DashboardDefault.vue?vue&type=script&lang=js"
import style0 from "./DashboardDefault.vue?vue&type=style&index=0&id=e13339fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports